import {
  ApiAudienceDocShareLinkStatus,
  getAudienceDocShareLinkStatusQueryKey,
} from '@kaiizen/kai-pro-api';
import { useCachedQuery, useQueryCacheMutation } from '@kaiizen/react-persistent-cache';

import { useKaiProApiClient } from '../useKaiProApiClient';

export const useAudienceDocShareLinkStatus = (
  scanId: string | undefined,
  options?: { enabled?: boolean },
) => {
  const kaiProApiClient = useKaiProApiClient();
  const { enabled = true } = options ?? {};

  const query = useCachedQuery<ApiAudienceDocShareLinkStatus>(
    getAudienceDocShareLinkStatusQueryKey(scanId),
    () => kaiProApiClient.getAudienceDocShareLinkStatus(scanId!),
    { enabled: !!kaiProApiClient.token && !!scanId && enabled },
  );

  return {
    ...query,
    shareLinkStatus: query.data,
  };
};

export const useAudienceDocShareLinkMutators = () => {
  const kaiProApiClient = useKaiProApiClient();

  const createMutation = useQueryCacheMutation(
    async (scanId: string) => kaiProApiClient.createAudienceDocShareLink(scanId),
  );
  const revokeMutation = useQueryCacheMutation(
    async (scanId: string) => kaiProApiClient.revokeAudienceDocShareLink(scanId),
  );

  return {
    createAudienceDocShareLink: createMutation.mutate,
    isCreatingAudienceDocShareLink: createMutation.isPending,
    revokeAudienceDocShareLink: revokeMutation.mutate,
    isRevokingAudienceDocShareLink: revokeMutation.isPending,
  };
};
